import { render, staticRenderFns } from "./SiteCard.vue?vue&type=template&id=4648d35e&scoped=true&"
import script from "./SiteCard.vue?vue&type=script&lang=js&"
export * from "./SiteCard.vue?vue&type=script&lang=js&"
import style0 from "./SiteCard.vue?vue&type=style&index=0&id=4648d35e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4648d35e",
  null
  
)

export default component.exports